import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Questions, QuestionsBanner } from "../components/QuestionsComp";

const Questionspage = () => {
    return (
       <>
       <title>Commonly Asked Questions</title>
       <Header/>
       <QuestionsBanner/>
       <Questions/>
       <Footer/>
       </>
    );
};

export default Questionspage;